import EntityTagListPopoverContent from "@/admin/settings/tabs/EntityTagListPopoverContent"
import { GlobalID } from "@/relay/RelayTypes"
import { DiscoDropdown, DiscoIcon } from "@disco-ui"
import DiscoDropdownItem from "@disco-ui/dropdown/DiscoDropdownItem"
import useFeatureFlags from "@utils/hook/useFeatureFlags"
import { TestIDProps } from "@utils/typeUtils"
export type ProductFilterBy = "tags"

type ProductListTagsOption = {
  value: GlobalID
  title: string
}

export type ProductListEntityTagsFilterState = {
  entityTags: ProductListTagsOption[]
}

type ProductListTagsDropdownProps = TestIDProps & {
  filterState: ProductListEntityTagsFilterState
  setFilterState: (state: ProductListEntityTagsFilterState) => void
}

function ProductListTagsDropdown({
  testid = "ProductListTagsDropdown",
  filterState,
  setFilterState,
}: ProductListTagsDropdownProps) {
  const { tagging } = useFeatureFlags()
  if (!tagging) return null

  return (
    <DiscoDropdown
      menuButton={({ onClick }) => (
        <DiscoDropdownItem
          testid={`${testid}.tags-select.dropdown-button`}
          title={"Tags"}
          icon={<DiscoIcon icon={"tag"} />}
          rightIcon={<DiscoIcon icon={"chevron"} rotate={"90"} />}
          onClick={onClick}
        />
      )}
      transformOrigin={{ vertical: "top", horizontal: "left" }}
      isNested
      mountChildrenOnOpen
      disableCloseOnClick
    >
      <EntityTagListPopoverContent
        testid={`${testid}.tags-select`}
        filterState={filterState}
        setFilterState={setFilterState}
      />
    </DiscoDropdown>
  )
}

export default ProductListTagsDropdown
